/// <amd-module name="Test/Analytics/Widgets/OverallStateWidgetConstants" />
export const IconMapping = {
    TestPlan: "TestPlan",
    TestPoint: "TestBeaker",
    PassRate: "CheckMark"
};

export const OverallStateWidgetConstants = {
    PieChartHeight: 90,
    PieChartWidth: 90,
    PieChartRadius: 45,
    DonutChartDiameter: 100
}

